import React from "react";
import FilterTable from "./FilterTable";

export default function SmsDelivery() {
  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <section className="cmp">
          <div className="container-fluid">
            {/* <div className="row"> */}
            {/* <!--left-panel-section--> */}

            {/* <!--x-left-panel-section-x--> */}
            {/* <!--right-panel-section--> */}
            {/* <section className="col-md-9 right_panel px-0"> */}
            {/* <!--header-section--> */}
            {/* <header className="header_1 py-1">
            <div className="container-fluid">
              <div className="float-end d-flex d_block align-items-center">
                <a
                  href="#"
                  className="btn_primary d-block d_inline_flex align-items-center py-1 px-4"
                >
                  <span className="d-block spn_8 text-capitalize">
                    click here to
                  </span>
                  <span className="d-block text-uppercase ms_2">buy now!</span>
                </a>
                <div className="d-flex align-items-center d_fx ms-4">
                  <div className="">
              
                    <div className="float-end d-flex align-items-center spn_9">
                      <i className="fas fa-envelope d-block"></i>
                      <span className="d-block text-capitalize ms-2">
                        sunday,22-july-2018-04:26:14 PM
                      </span>
                    </div>
             
                    <div className="d-flex chanl cl_both">
                      <span className="d-block text-capitalize">
                        promo : 224
                      </span>
                      <span className="d-block text-capitalize mx-3">
                        trans : 17
                      </span>
                      <span className="d-block text-capitalize">
                        miss call : 0
                      </span>
                      <span className="d-block text-capitalize ms-3">
                        IBalance : 0.0000
                      </span>
                    </div>
                  </div>
                  <div className="flt_end ms-4 m_0">
                    <div className="dropdown d_block float_end">
                      <a
                        className="btn profile_8 d-flex align-items-center dropdown-toggle p-0"
                        href="#"
                        role="button"
                        id="dropdownMenuLink"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i className="fas fa-user d-block"></i>
                        <span className="d-block text-uppercase mx-1">
                          demo1
                        </span>
                      </a>
                      <div
                        className="dropdown-menu m-0 sub_mnu pt-4 pb-0"
                        aria-labelledby="dropdownMenuLink"
                      >
                        <div className="d-flex justify-content-between prfl_8">
                          <a className="d-block">
                            <i className="fas fa-user d-block text-center"></i>
                            <span className="d-block text-capitalize">
                              profile
                            </span>
                          </a>
                          <a className="d-block">
                            <i className="fas fa-wallet d-block text-center"></i>
                            <span className="d-block text-capitalize">
                              wallet
                            </span>
                          </a>
                          <a className="d-block">
                            <i className="fas fa-key d-block text-center"></i>
                            <span className="d-block text-capitalize">
                              password
                            </span>
                          </a>
                        </div>
                        <div className="my-2 px-2">
                          <h6 className="text-center text-capitalize m-0">
                            account manager : raj mishra
                          </h6>
                          <div className="d-flex justify-content-center align-items-center eml_mn my-1">
                            <i className="fas fa-mobile-alt d-block"></i>
                            <span className="d-block">:</span>
                            <span className="d-block ms-2">9876099999</span>
                          </div>
                          <div className="d-flex justify-content-center align-items-center eml_mn">
                            <i className="fas fa-envelope d-block"></i>
                            <span className="d-block">:</span>
                            <span className="d-block ms-2">info@stripl.in</span>
                          </div>
                        </div>
                        <div className="log_out">
                          <i className="fas fa-lock d-block text-center"></i>
                          <span className="d-block text-uppercase text-center mt-1">
                            {" "}
                            log out
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </header> */}

            <div className="container-fluid_1">
              <section className="marquee_8">
                <div className="d-flex justify-content-between">
                  <marquee>
                    wdvfwerve wrevwer vwewer wevwer errwfrv erwvervr wevevrrvew
                    wvervwervwe
                  </marquee>
                  {/* <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modl"
                    aria-label="Close"
                  ></button> */}
                </div>
              </section>
              {/* <!--x-marquee-section-x--> */}
              {/* <!--sms-headline-section--> */}
              {/* <section className="sms_8 my-4">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex  align-items-center">
                  <i className="fas fa-sms d-block"></i>
                  <h6 className="text-uppercase m-0 mx-1">send sms /</h6>
                  <p className="text-capitalize m-0">welcome demo1</p>
                  <i className="fas fa-info-circle d-block ms-1"></i>
                </div>
                <p className="text-capitalize">home / send SMS</p>
              </div>
            </section> */}
              {/* <header className="header_1 py-1">
                <div className="container-fluid">
                  <div className="float-end d-flex d_block align-items-center">
                  
                    <div className="d-flex align-items-center d_fx ms-4">
                      <div className="">
                       
                        <div className="d-flex chanl cl_both">
                          <span className="d-block text-capitalize">
                            promo : 224
                          </span>
                          <span className="d-block text-capitalize mx-3">
                            trans : 17
                          </span>
                          <span className="d-block text-capitalize">
                            miss call : 0
                          </span>
                          <span className="d-block text-capitalize ms-3">
                            IBalance : 0.0000
                          </span>
                        </div>
                      </div>
     
                    </div>
                  </div>
                </div>
              </header> */}
              {/* <!--x-sms-headline-section-x--> */}
              {/* <!--sms-delivery-section--> */}
              <section className="sms_dlvry py-2 mt-3">
                <ul
                  className="nav nav-pills mb-3"
                  id="pills-tab"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="pills-home-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-home"
                      type="button"
                      role="tab"
                      aria-controls="pills-home"
                      aria-selected="true"
                    >
                      Home
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="pills-profile-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-profile"
                      type="button"
                      role="tab"
                      aria-controls="pills-profile"
                      aria-selected="false"
                    >
                      Profile
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="pills-contact-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-contact"
                      type="button"
                      role="tab"
                      aria-controls="pills-contact"
                      aria-selected="false"
                    >
                      Contact
                    </button>
                  </li>
                </ul>
                <div className="tab-content" id="pills-tabContent">
                  <div
                    className="tab-pane fade show active"
                    id="pills-home"
                    role="tabpanel"
                    aria-labelledby="pills-home-tab"
                  >
                    <div className="dropdown">
                      <a
                        className="btn btn_primary dropdown-toggle d-flex align-items-center text-capitalize"
                        href="#"
                        role="button"
                        id="dropdownMenuLink"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i className="fas fa-calendar-alt d-block"></i>
                        <span className="d-block mx-1">data range</span>
                      </a>
                      <ul
                        className="dropdown-menu sub_mnu_1"
                        aria-labelledby="dropdownMenuLink"
                      >
                        <li>
                          <a className="dropdown-item" href="#">
                            Action
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="#">
                            Another action
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="#">
                            Something else here
                          </a>
                        </li>
                      </ul>
                    </div>
                    <FilterTable />
                    {/* <div className="d-flex justify-content-between align-items-center flex-wrap my-4">
                    <div className="d-flex align-items-center float_start">
                      <p className="text-capitalize">show</p>
                      <select
                        className="form-select mx-2"
                        aria-label="Default select example"
                      >
                        <option selected>1</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                      </select>
                      <p className="text-capitalize">entries</p>
                    </div>
                    <div className="d-flex align-items-center clear_both mnt_1">
                      <label
                        for="exampleInputText1"
                        className="form-label d-block text-capitalize m-0"
                      >
                        search:
                      </label>
                      <input
                        type="text"
                        className="form-control ms-2"
                        id="exampleInputText1"
                        aria-describedby="emailHelp"
                      />
                    </div>
                  </div> */}
                    {/* <div className="table-responsive"> */}

                    {/* <table>
                      <thead>
                        <tr>
                          <th>date</th>
                          <th>name</th>
                          <th>senderId</th>
                          <th>message</th>
                          <th>interface</th>
                          <th>channel</th>
                          <th>credit used</th>
                          <th>view</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            bhkjjbhbhbh vggvv vgvgjgvj vgjgvgvj vgvjgvg vgvgvgg
                            fffchfchh cffccffcfc
                          </td>
                          <td>bkhbbbbbbbvv</td>
                          <td>bhkjjbhbhbh</td>
                          <td style={{ minWidth: "188px" }}>bkhbbbbbbbvv</td>
                          <td>bhkjjbhbhbh</td>
                          <td>bkhbbbbbbbvv</td>
                          <td>bhkjjbhbhbh</td>
                          <td>
                            <div className="">
                              <div className="dropdown">
                                <a
                                  className="btn btn_secondary dropdown-toggle p-0"
                                  href="#"
                                  role="button"
                                  id="dropdownMenuLink"
                                  data-bs-toggle="dropdown"
                                  data-bs-auto-close="outside"
                                  aria-expanded="false"
                                >
                                  <i
                                    className="fas fa-info d-block float-start ic_2"
                                    id="ic_2"
                                  ></i>
                                </a>

                                <ul
                                  className="dropdown-menu px-3"
                                  aria-labelledby="dropdownMenuLink"
                                  id="sub_menu"
                                >
                                  <div className="bux_8">
                                    <i
                                      className="fas fa-times d-block float-end menu_btn"
                                      id="menu_btn"
                                      onclick="menu()"
                                    ></i>
                                  </div>
                                  <div className="mt-2">
                                    <div className="row justify-content-between mx-0">
                                      <div className="col-1 fw-bold text-capitalize px-0">
                                        status
                                      </div>
                                      <div className="col-1 fw-bold text-capitalize px-0">
                                        count
                                      </div>
                                    </div>
                                    <div className="row justify-content-between mx-0">
                                      <div className="col-1 text-capitalize px-0">
                                        delivered
                                      </div>
                                      <div className="col-1 text-capitalize px-0">
                                        1
                                      </div>
                                    </div>
                                    <div className="row justify-content-between mx-0">
                                      <div className="col-1 text-capitalize px-0">
                                        rejected
                                      </div>
                                      <div className="col-1 text-capitalize px-0">
                                        1
                                      </div>
                                    </div>
                                    <div className="row justify-content-between mx-0">
                                      <div className="col-1 text-capitalize px-0">
                                        sent
                                      </div>
                                      <div className="col-1 text-capitalize px-0">
                                        1
                                      </div>
                                    </div>
                                  </div>
                                </ul>
                              </div>
                            </div>

                            <div className="mt-2 text-center">
                              <i className="fas fa-download dwnld"></i>
                            </div>

                        
                          </td>
                        </tr>
                      </tbody>
                    </table> */}
                    {/* </div> */}
                    {/* <div className="d-flex d_block justify-content-between align-items-center flex-wrap mt-4">
                    <p className="">Showing 1 to 2 of 2 entries</p>
                    <div className="d-flex btn_flex align-items-center mt_1">
                      <button
                        type="button"
                        className="btn btn-outline-primary d-block text-capitalize m-0"
                      >
                        first
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-primary d-block text-capitalize m-0"
                      >
                        previous
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-primary d-block text-capitalize m-0"
                      >
                        1
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-primary d-block text-capitalize m-0"
                      >
                        next
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-primary d-block text-capitalize m-0"
                      >
                        last
                      </button>
                    </div>
                  </div> */}
                  </div>
                  <div
                    className="tab-pane fade"
                    id="pills-profile"
                    role="tabpanel"
                    aria-labelledby="pills-profile-tab"
                  >
                    ...
                  </div>
                  <div
                    className="tab-pane fade"
                    id="pills-contact"
                    role="tabpanel"
                    aria-labelledby="pills-contact-tab"
                  >
                    ...
                  </div>
                </div>
              </section>
              {/* <!--x-sms-delivery-section-x--> */}
            </div>
            {/* </section> */}
            {/* <!--x-right-panel-section-x--> */}
            {/* </div> */}
          </div>
        </section>
      </main>
    </>
  );
}
